import { library } from '@fortawesome/fontawesome-svg-core'

import { faIdCard } from '@fortawesome/pro-solid-svg-icons/faIdCard'
import { faMapSigns } from '@fortawesome/pro-solid-svg-icons/faMapSigns'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faUserFriends } from '@fortawesome/pro-solid-svg-icons/faUserFriends'
import { faArrowAltLeft } from '@fortawesome/pro-solid-svg-icons/faArrowAltLeft'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'

library.add(
  faIdCard, faMapSigns, faPlus, faPlusCircle, faPencil, faUserFriends, faArrowAltLeft, faSearch, faCaretDown,
  faCaretUp, faUsers
)
